<template>
  <div class="title-box">
    <div class="title-zh">{{title.titleZh}}</div>
    <div class="title-en">{{title.titleEn}}</div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: Object,
      default() {
        return {
          titleZh: "标题组件说明:",
          titleEn: "props:title, type[Object], {titleZh, titleEn}"
        };
      }
    }
  }
};
</script>

<style lang="less" scoped>
.title-box {
  text-align: center;
  padding: 50px;
  cursor: default;
  .title-zh {
    display: inline-block;
    border-bottom: 2px solid #ddd;
    font-size: 24px;
    color: #007eff;
  }
  .title-en {
    font-size: 16px;
    color: #999;
  }
}

</style>

